import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GoAlert } from "react-icons/go";

const ConfirmationModal = ({
  closeModal,
  data = {},
  disabled = false,
  callbackData = null,
}) => {
  return (
    <>
      <DialogTitle display="flex" alignItems="center" gap={1}>
        <GoAlert color="red" size="1.5rem" /> {data.title || "مطمئن هستید"}
      </DialogTitle>
      <DialogContent sx={{ lineHeight: "1.6em" }}>{data.content}</DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>{data.cancelBtn || "انصراف"}</Button>
        <Button
          onClick={() => data.submitFunc(callbackData)}
          variant="contained"
          disabled={disabled}
        >
          {data.submitBtn || "تایید"}
        </Button>
      </DialogActions>
    </>
  );
};

export default ConfirmationModal;
